interface LocalStorage {
  getItem<T = any>(key: string): T | null
  setItem(key: string, value: any): boolean
  removeItem(key: string): void
  clear(): void
}
  

function getItem<T>(key: string): T | null {
  try {
    const value = window.localStorage.getItem(key)

    if (value !== null && value !== undefined) {
      return JSON.parse(value);
    }

    return null;
  } catch {
    return null;
  }
}

function setItem(key: string, value: any): boolean {
  try {
    const stringifiedValue = JSON.stringify(value)
    window.localStorage.setItem(key, stringifiedValue)
    return true;
  } catch {
    return false;
  }
}

function removeItem(key: string) {
  window.localStorage.removeItem(key)
}

function clear() {
  window.localStorage.clear()
}

export const LocalStorage: LocalStorage = {
  getItem,
  setItem,
  removeItem,
  clear,
};
